export const COS_18 = Math.cos(Math.PI/10)
export const COS_36 = Math.cos(Math.PI/5)
export const COS_54 = Math.cos(3*Math.PI/10)
export const COS_72 = Math.cos(2*Math.PI/5)
export const SIN_18 = Math.sin(Math.PI/10)
export const SIN_36 = Math.sin(Math.PI/5)
export const SIN_54 = Math.sin(3*Math.PI/10)
export const SIN_72 = Math.sin(2*Math.PI/5)